module.exports = __webpack_public_path__ + "img/logo.a5323420.svg";